import React from 'react';
import PropTypes from 'prop-types';
import { InputGroupSC } from './input.styled';

const InputGroup = ({ label, className, onChange, placeholder, type, value, hasError }) => {
  return (
    <InputGroupSC className={className}>
      {label ? <label>{label}</label> : null}
      <input type={type} value={value} onChange={onChange} placeholder={placeholder} />
    </InputGroupSC>
  );
};

InputGroup.defaultProps = {
  className: '',
};

InputGroup.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputGroup;
